import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LoggerService } from '../logger-service/logger-service.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  public handleError(err: any): void {
    if (environment.rollbar.enabled) {
      const logService = this.injector.get(LoggerService);
      if (err !== 'cordova_not_available') {
        logService.critical(err.originalError || err);
      }
    }

    throw err;
  }
}
